import { render, staticRenderFns } from "./EventTraining.vue?vue&type=template&id=5f4355c4&scoped=true&"
import script from "./EventTraining.vue?vue&type=script&lang=js&"
export * from "./EventTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4355c4",
  null
  
)

export default component.exports